import { Builder } from '@builder.io/react';
import { BUILDER_DIVIDER_NAMES } from '../BuilderComponentsName';
import ULPackageBuilder from '../components/sections/ULPackage.builder';

Builder.registerComponent(ULPackageBuilder, {
    name: BUILDER_DIVIDER_NAMES.UnlimitedPackage,
});
